import { useEffect, useState } from "react";
import { IntervalConfiguration } from "../../../utils/configurationProvider";
import SvgComponent from "../../_utils/SVGComponent";
import "./index.css";
import ICONS from "../../../assets/Icons";

/**
 * @param {Object} props
 * @param {boolean} props.isDisabled
 * @param {Array} props.quantity - state for quantity
 * @param {Array} props.setQuantity - setter for quantity
 * @returns {JSX.Element}
 */
const CommonQuantity = ({ quantity, setQuantity, isDisabled }) => {
  const [isInput, setIsInput] = useState(false);
  const [animateUp, setAnimateUp] = useState(null);
  const increment = (e) => {
    e.stopPropagation();
    if (!isInput && quantity < 1000000) {
      setAnimateUp(true);
      setTimeout(() => {
        setQuantity(quantity + 1);
      }, IntervalConfiguration.intervalMid);
    }
  };

  const decrement = (e) => {
    e.stopPropagation();
    if (!isInput && quantity != 0) {
      setAnimateUp(false);
      setTimeout(() => {
        setQuantity(quantity - 1);
      }, IntervalConfiguration.intervalMid);
    }
  };

  useEffect(() => {
    if (animateUp !== null) {
      const timer = setTimeout(() => {
        setAnimateUp(null);
      }, IntervalConfiguration.intervalSmall);
      return () => clearTimeout(timer);
    }
  }, [animateUp]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isInput) {
        setAnimateUp(null);
        if (!quantity) {
          setQuantity(0);
        }
        setIsInput((x) => !x);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isInput, quantity]);

  const handleAmtInput = (e) => {
    const { value } = e.target;
    const sanitizedText = value.replace(/[^0-9]/g, "");

    if (sanitizedText === "") {
      setQuantity(0);
      return;
    }
    const amount = parseInt(sanitizedText);
    if (!isNaN(amount) && amount <= 1000000) {
      setQuantity(amount);
    }
  };

  const handleEnterKey = (e) => {
    if (e.key === "Enter" && quantity) {
      setIsInput(false);
    }
  };

  return (
    <div
      className={`max-w-quantity-field-width w-width-full overflow-hidden rounded-border-radius-md flex justify-between items-center bg-primary-nav-act p-padding-sm ${isDisabled ? "opacity-light-opacity pointer-events-none cursor-not-allowed" : ""}`}
    >
      <div
        onClick={decrement}
        className={`w-icon-md h-icon-md ${quantity === 0 || isInput ? "cursor-not-allowed" : "global-hover-black cursor-pointer"}   rounded-full relative z-z-index-overlay`}
      >
        <div
          className={`z-z-index-base ${quantity === 0 || isInput ? "opacity-light-opacity" : "hover:opacity-dark-opacity"} relative`}
        >
          <SvgComponent
            height="var(--icon-md)"
            width="var(--icon-md)"
            url={ICONS?.MINUS_WHITE}
            color="var(--text-primary)"
            alt="minus"
          />
        </div>
      </div>
      {!isInput ? (
        <p
          onClick={(e) => {
            e.stopPropagation();
            setIsInput(true);
          }}
          className={`w-max relative global-hover-white cursor-pointer rounded-border-radius-md hover:text-primary-bg z-z-index-base px-padding-button-s text-text-primary text-font-md ${animateUp ? "animate-up" : animateUp === false ? "animate-down" : ""}`}
        >
          {quantity}
        </p>
      ) : (
        <input
          onClick={(e) => e.stopPropagation()}
          autoFocus
          value={quantity}
          onInput={handleAmtInput}
          name="input"
          type="text"
          onKeyDown={handleEnterKey}
          className={`bg-primary-bg text-text-primary text-font-md px-padding-sm rounded-border-radius-md w-[85px]`}
        />
      )}
      <div
        onClick={increment}
        className={`w-icon-md h-icon-md  ${!isInput && !isDisabled ? "global-hover-black cursor-pointer" : "cursor-not-allowed"}   rounded-full relative z-z-index-overlay`}
      >
        <div
          className={`z-z-index-base ${!isInput && !isDisabled ? "hover:opacity-dark-opacity" : "opacity-light-opacity"} relative`}
        >
          <SvgComponent
            height="var(--icon-md)"
            width="var(--icon-md)"
            url={ICONS?.ADD_BUTTON_WHITE}
            color="var(--text-primary)"
            alt="plis"
          />
        </div>
      </div>{" "}
    </div>
  );
};

export default CommonQuantity;
